import { Injectable } from '@angular/core';
import { NavMenuItem } from './navMenuItem';
import { GatewayAPIService } from '../../core/gateway-api.service';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  constructor(private api: GatewayAPIService) {}

  getNavMenu(userId: string): Promise<NavMenuItem[]> {
    return this.api
      .apiCallSane(
        '/auth/nav-menu',
        'GET',
        this.api.getDefaultHeaders(),
        { userId: userId },
        null,
        { authenticate: true, setRoot: true },
      )
      .then((nav: Partial<NavMenuItem>[]) =>
        nav.map((n) => new NavMenuItem(n)),
      );
  }

  // This should be called once per user session and stored
  public generateAccessTable(
    allNamespaces: any[],
    bits: string,
  ): Map<string, boolean> {
    let accessTable: Map<string, boolean> = new Map<string, boolean>();
    for (var i = 0; i < allNamespaces.length; i++) {
      accessTable.set(
        allNamespaces[i].name,
        NavService.checkUserAccess(allNamespaces, allNamespaces[i].name, bits),
      );
    }
    return accessTable;
  }

  public static checkUserAccess(
    access: any[],
    namespace: string,
    bits: string,
  ): boolean {
    //let access = this.storage.getAllAccessNamespaces()
    let index: number = -1;

    if (bits) {
      for (var i = 0; i < access.length; i++) {
        if (access[i].name == namespace) {
          index = access[i].index;
          break;
        }
      }

      return bits.charAt(index) == '1';
    }
    return false;
  }
}
